import { toast, ajax as Ajax, isFunction, isArray, isEmpty, isObj, ViewModel, localeLang, localTimeToServer, serverTimeToLocal } from '@platform/api';
import { moment } from '@platform/api';
import {
    _getAllSearchData,
    setSearchPlanName,
} from './methods';

let { removeGlobalStorage } = ViewModel;

// =========以下为平台内部使用的方法========================

let OperationOptions = [];
export function setOperationOptionsMultiLang(_multiLang) {
    const multiLang = _multiLang;
    if (isEmpty(OperationOptions) && !isEmpty(_multiLang)) {
        OperationOptions = [
            {
                display: multiLang['page-search-0047'],
                value: '=',
            },
            {
                display: multiLang['page-search-0048'],
                value: '>',
            },
            {
                display: multiLang['page-search-0049'],
                value: '<',
            },
            {
                display: multiLang['page-search-0050'],
                value: 'between',
            },
            {
                display: multiLang['page-search-0051'],
                value: '>=',
            },
            {
                display: multiLang['page-search-0052'],
                value: '<=',
            },
            {
                display: multiLang['page-search-0053'],
                value: '<>',
            },
            {
                display: multiLang['page-search-0054'],
                value: 'like',
            },
            {
                display: multiLang['page-search-0055'],
                value: 'left like',
            },
            {
                display: multiLang['page-search-0056'],
                value: 'right like',
            },
            {
                display: multiLang['page-search-0057'],
                value: 'is null',
            },
            {
                display: multiLang['page-search-0084'],
                value: 'not like',
            },
            {
                display: multiLang['page-search-0085'],
                value: 'is not null',
            },
        ];
    }
}
//处理自然时间转多时区和起终点 time 是时间 flage：start 当天0点，end当天24点 假就是不处理
export function naturalTimeHandler(time, flag, isconverttimezones) {
    let format = '';
    switch (flag) {
        case 'start':
            format = 'YYYY-MM-DD HH:mm:ss';
            break;
        case 'end':
            format = 'YYYY-MM-DD HH:mm:ss';
            break;
    }
    const loc = serverTimeToLocal(moment(time), isconverttimezones).format(format);
    const dong8 = localTimeToServer(moment(loc), isconverttimezones).format(format);
    return dong8;

}
/* 处理运算符 */
export function createOperation(data) {
    let newArr = [];
    if (!data) return newArr;
    //去掉开头和结尾的@符号
    data = data.replace(/^@+|\sic|@$/g, '');
    let o = data.split('@');
    o.forEach(item => {
        for (let i = 0; i < OperationOptions.length; i++) {
            if (item === OperationOptions[i].value) {
                newArr.push(OperationOptions[i]);
                break;
            }
        }
    });
    return newArr;
}
export function _clone(obj) {
    return JSON.parse(JSON.stringify(obj === undefined ? '' : obj));
}

export function getTimezoneOffset() {
    return -1 * new Date().getTimezoneOffset() / 60;
}
//从缓存中获取函数翻译值
export function getFunctionValueFromViewModal(VALUE, context = {}, attrcode) {
    let reslut = _clone(VALUE);
    attrcode = '';//暂时去掉根据attrcode过滤的条件。
    let mainorgVal = context.pk_org || '';
    if (mainorgVal && attrcode === 'pk_org' && Array.isArray(context.permOrgs) && !context.permOrgs.includes(mainorgVal)) {
        mainorgVal = '';
    }
    let obj = {
        '#mainorg#': {
            // 默认主组织
            display: mainorgVal ? context.org_Name : '',
            value: mainorgVal,
        },
        '#DefaultCostRegion#': {
            // 默认财务成本域
            display: context.defaultCostRegionName || '',
            value: context.defaultCostRegionPk || '',
        },
        '#DefaultCreditCtlRegion#': {
            //默认信用域
            display: context.defaultCreditCtlRegionName || '',
            value: context.defaultCreditCtlRegionPk || '',
        },
        '#accountingbook#': {
            //默认账簿
            display: context.defaultAccbookName || '',
            value: context.defaultAccbookPk || '',
        },
        '#operator#': {
            //当前操作员
            display: context.userName || '',
            value: context.userId || '',
        },
        '#currentgroup#': {
            //当前集团
            display: context.groupName || '',
            value: context.groupId || '',
        },
        '#DefaultLiactCostrgFunction#': {
            //默认利润中心成本域
            display: context.defaultCenterContentName || '',
            value: context.defaultCenterContentPK || '',
        },
        "#DefaultCostrgOrLiactCostrgFunc#": {
            //默认成本域
            display: context.defaultCostRegionName || context.defaultCenterContentName || '',
            value: context.defaultCostRegionPk || context.defaultCenterContentPK || '',
        },
        "#busioperator#": {
            //当前人员
            display: context.defaultPsndocName || '',
            value: context.defaultPsndocPK || '',
        },
        "#rbacdept#": {
            //当前人员所属部门 
            display: context.defaultDeptName || '',
            value: context.defaultDeptPK || '',
        },
        "#globeorg#": {
            //全局  
            display: context.globeName || '',
            value: context.globePK || '',
        },
        "#currperiod#": {
            //当前计划周期 
            display: context.currperiodName || '',
            value: context.currperiodPK || '',
        },
        "#mainaccperiod#": {
            //默认会计期间 
            display: context.mainacceperiodName || '',
            value: context.mainAcceperiodPK || '',
        },
        "#currentaccperiod#": {
            //当前期间 
            display: context.currentAccperiodName || '',
            value: context.currentAccperiodPk || '',
        },
        "#rbacdeptsubincluded#": {
            //用户主职部门及其下级  数组
            display: Array.isArray(context.defaultDeptsubincludedName) ? context.defaultDeptsubincludedName.join(',') : context.defaultDeptsubincludedName || '',
            value: Array.isArray(context.defaultDeptsubincludedPK) ? context.defaultDeptsubincludedPK.join(',') : context.defaultDeptsubincludedPK || '',
        },
        "#rbacdeptpart#": {
            //当前用户主职部门、当前用户主职部门及下级部门
            display: Array.isArray(context.defaultDeptPartName) ? context.defaultDeptPartName .join(',') : context.defaultDeptPartName || '',
            value: Array.isArray(context.defaultDeptPartPK) ? context.defaultDeptPartPK.join(',') : context.defaultDeptPartPK || '',
        },
        "#firstaccperiod#": {
            //第一个期间 
            display: context.fristAccperiodName || '',
            value: context.fristAccperiodPK || '',
        },
        "#accountingbook#": {
            //默认（总账）账簿 
            display: context.accountingBookName || '',
            value: context.accountingBookPk || '',
        },
        "#userorg#": {
            display: context.userOrgName || '',
            value: context.userOrgPk || '',
        },
    };

    if (Array.isArray(reslut)) {
        reslut.map(item => {
            if (item.value && item.value.indexOf('#') !== -1) {
                item = obj[item.value] || item;
            } else if (attrcode === 'pk_org' && item.value && Array.isArray(context.permOrgs) && !context.permOrgs.includes(item.value)) {
                item.value = '';
                item.display = '';
            }
            return item;
        });
    } else {
        if (reslut.value && reslut.value.indexOf('#') !== -1) {
            reslut = obj[reslut.value] || reslut;
        } else if (attrcode === 'pk_org' && reslut.value && Array.isArray(context.permOrgs)) {
            let vArray = reslut.value.split(',');
            let DisArray = reslut.display.split(',');
            let filterVal = [];
            let filterDis = [];
            for (let index = 0; index < vArray.length; index++) {
                let el = vArray[index];
                if (context.permOrgs.includes(el)) {
                    filterVal.push(el);
                    filterDis.push(DisArray[index]);
                }
            }
            reslut.value = filterVal.join(',');
            reslut.display = filterDis.join(',');
        }
    }
    return reslut;
}

//初始化查询区需要的数据searchInfo
export function initSearchArea(props, info) {
    let isEdit = false;//模板是否改变
    let flag = false;//标识是否是第一次初始化
    let meta = props.meta;
    if (!info.isCompleted) {
        let isclosequickquery = meta.isclosequickquery;
        let defaultDisPlay = meta.defaultDisPlay;
        //如果没有高级就一直展开，如果有高级就按照isunfold为true展开
        info.showSearchItems = !meta.isunfold;
        info.showSearchItems = props.showAdvBtn ? info.showSearchItems : false;
        info.showAdvModal = false; // 高级面板的显隐性
        let conditions;
        if (defaultDisPlay && defaultDisPlay !== '00000000000000000000') {
            conditions = Array.isArray(meta.queryschemes) && meta.queryschemes.find(item => item.pk_ncc_queryscheme === defaultDisPlay);
        } else if (!isclosequickquery && !defaultDisPlay) {
            conditions = Array.isArray(meta.queryschemes) && meta.queryschemes.find(item => item.isquickqs && item.isprepared === true);
            if (conditions) {
                meta.defaultPrepared = conditions.pk_ncc_queryscheme;
            }
        }
        if (conditions) {
            // 默认方案添加到当前方案
            info.currentPlan = conditions;
        } else {
            info.currentPlan = info.defaultPlan;
        }
    }
    if (info.currentPlan.isMyPlan) {
        let prev = info.currentPlan.renderobj4web;
        let next = info.defaultPlan.renderobj4web;
        let prevLenth = prev.length;
        let nextLenth = next.length;
        if (!info.searchKey) {
            isEdit = true;
        } else if (prevLenth !== nextLenth) {
            isEdit = true;
        } else {
            for (let index = 0; index < prev.length; index++) {
                if (prev[index].attrcode !== next[index].attrcode) {
                    isEdit = true;
                    break;
                }
            }
        }
        if (isEdit) {
            info.currentPlan.renderobj4web = info.defaultPlan.renderobj4web;
        }
    } else {
        let plan = info.searchPlanCache.find(item => item.pk_ncc_queryscheme == info.currentPlan.pk_ncc_queryscheme);
        //说明查询区的查询方案变了
        if (!plan) {
            info.currentPlan = info.defaultPlan;
        }
    }

    info.isDefaultPlan = info.currentPlan.pk_ncc_queryscheme == '001';
    info.searchPlanName = info.currentPlan.name;
    //初始化并恢复快照
    initSimpleSnap(props.context, info, info.currentPlan, true, isEdit);
    info.snapshotMap['simple'] = info.currentPlan.renderobj4web_snap;

    if (!info.hasOwnProperty('isCompleted')) {
        info.isCompleted = true;
        flag = true;
    }
    if (flag) {
        isFunction(props.setInitValueEvent) && (props.setInitValueEvent('simple'));
    }

}
// 展开查询方案 并处理成 快照
export function spreadQueryPlan(context, planItems, temItem, preSnapMap = {}, level = 0) {
    if (Array.isArray(planItems)) {
        return planItems.map(item => {
            if (Array.isArray(item.children)) {
                item.children = spreadQueryPlan(context, item.children, temItem, preSnapMap, ++level);
                return item;
            } else {
                let initialvalue = { value: '', display: '' };
                //如果原来有值，就将值赋给新的快照
                if (preSnapMap[item.attrcode]) {
                    item.initialvalue = preSnapMap[item.attrcode];
                }
                //如果item.initialvalue存在
                if (item.initialvalue && typeof item.initialvalue === "object") {
                    initialvalue.value = item.initialvalue.value || '';
                    initialvalue.display = item.initialvalue.display || '';
                }
                let tempItem = temItem[item.attrcode];
                if (tempItem) {
                    if (tempItem.itemtype === 'checkbox_switch') {
                        if (initialvalue.value) {
                            initialvalue.value = true;
                        } else {
                            initialvalue.value = false;
                        }
                    } else if (tempItem.itemtype === 'refer') {
                        let refervalue = getFunctionValueFromViewModal(initialvalue, context, tempItem.attrcode);
                        initialvalue.display = refervalue.display;
                    } else if (tempItem.itemtype === 'residtxt') {
                        let index = tempItem.languageMeta.filter(val => val.languageCode == localeLang)[0]?.index || 1;
                        //这里在看看有没有问题xiqq
                        initialvalue.index = index;
                    }
                    let visible = item.visible === false ? false : true;
                    let operationOptions = (Array.isArray(item.operationOptions) && item.operationOptions.length > 0) ? item.operationOptions : createOperation(tempItem.queryOperateType);
                    let operationSign = '=';
                    if (tempItem.queryOperateType) {
                        operationSign = tempItem.queryOperateType.replace(/^@+|\sic|@$/g, '').split('@')[0];
                    }
                    let obj = {
                        attrcode: tempItem.attrcode,
                        refpk: tempItem.attrcode,
                        initialvalue: initialvalue,
                        operationOptions: operationOptions,
                        remove: item.remove !== undefined ? item.remove : !(tempItem.required || tempItem.isfixedcondition),
                        label: tempItem.label,
                        isfixedcondition: !!tempItem.isfixedcondition,
                        isExtend: item.isExtend !== undefined ? item.isExtend : !!tempItem.isfixedcondition,
                        operationSign: item.operationSign || operationSign || '=',
                        visible: visible,
                        itemtype: tempItem.itemtype,
                        isconverttimezones: tempItem.isconverttimezones,
                    };
                    if (tempItem.itemtype === 'residtxt') {
                        if (!isEmpty(item.valueMap)) {
                            obj.valueMap = item.valueMap;
                        } else if (initialvalue.value) {
                            obj.valueMap = {};
                            obj.valueMap[item.attrcode + initialvalue.index] = { value: initialvalue.value };
                        }
                    }
                    // if (tempItem.isfixedcondition && level < 2) {
                    //     obj.visible = false;
                    // }
                    return obj;
                }
            }
        }).filter(obj => obj && obj.visible);
    } else {
        return [];
    }
}
//初始化简单查询快照  打开高级查询的时候flag = true, isEdit = false; 切换查询方案的时候falg=false, isEdit = false
export function initSimpleSnap(context, info, currentPlan, flag = true, isEdit = false) {
    if (!currentPlan) return;
    //准备更新之前的查询区快照 首次渲染的时候没有
    let preSnap = currentPlan.renderobj4web_snap;
    let preSnapValueMap = {};
    //记录之前快照的value
    if (preSnap) {
        preSnap.forEach((item, index) => {
            preSnapValueMap[item.attrcode] = item.initialvalue;
        });
    }
    let isDefaultPlan = currentPlan.pk_ncc_queryscheme == '001';
    if (preSnap && flag) {
        if (isDefaultPlan) {
            if (isEdit) {
                currentPlan.renderobj4web_snap = spreadQueryPlan(context, currentPlan.renderobj4web, info.itemsMap, preSnapValueMap);
            }

        }
    } else {
        if (isDefaultPlan) {
            currentPlan.renderobj4web_snap = spreadQueryPlan(context, info.defaultPlan.renderobj4web, info.itemsMap);
        } else {
            if (currentPlan.renderobj4web && currentPlan.renderobj4web.length && currentPlan.renderobj4web[0].refpk === 'root') {
                currentPlan.renderobj4web[0].visible = true;
                let superSnap = [...info.fixedConditionGroup, ...currentPlan.renderobj4web[0].children];
                let currentPlanCopy = _clone(currentPlan);
                currentPlanCopy.renderobj4web[0].children = superSnap;
                currentPlan.renderobj4web_snap = spreadQueryPlan(context, currentPlanCopy.renderobj4web, info.itemsMap);
            } else {
                let filterFix = Array.isArray(currentPlan.renderobj4web) ? currentPlan.renderobj4web.filter(item => {
                    let fixCondition = info.fixedConditionGroup.find(a => a.attrcode == item.attrcode);
                    if (fixCondition) {
                        return false;
                    } else {
                        return true;
                    }
                }) : [];
                let normalSnap = [...info.fixedConditionGroup, ...filterFix];
                currentPlan.renderobj4web_snap = spreadQueryPlan(context, normalSnap, info.itemsMap);
            }
        }
    }

}

// 根据模板为查询区提供默认的 条件组的初始值
export function initDefaultSnapshot(items, context, isTemplateOrder) {
    let requireList = [];
    let fiexedList = [];
    let otherList = [];
    let snapshotList = [];
    if (isArray(items)) {
        snapshotList = items.filter(item => item.visible && item.isdrag);
        snapshotList.forEach((item, index) => {
            if (!(Number(item.visibleposition) > 0)) {
                item.visibleposition = 99999 + index;
            }
            if (item.isfixedcondition) {
                fiexedList.push(item);
            } else if (item.required) {
                requireList.push(item);
            } else {
                otherList.push(item);
            }
        });
        /**

         * 预置方案排序规则：查询模板中字段的排序分为“默认显示字段排序”、查询区域字段顺序、必填项顺序、固定条件顺序
排序规则：固定条件顺序>必填项顺序>默认显示字段排序中设置的顺序>查询区域字段顺序
举例：1.当一个字段设置了“默认显示字段排序”为10，在查询区域中字段显示在第12个，则在查询模板中此字段显示在第10的位置；
           2.当一个字段设置了“默认显示字段排序”为10，在查询区域中字段显示在第8个，又设置了固定条件，则此字段在查询模板中显示在第1位；
         */
        fiexedList.sort((v1, v2) => Number(v1.visibleposition) - Number(v2.visibleposition));
        if (isTemplateOrder) {
            const notFixed = requireList.concat(otherList).sort((v1, v2) => Number(v1.visibleposition) - Number(v2.visibleposition));
            snapshotList = fiexedList.concat(notFixed);
        } else {
            requireList.sort((v1, v2) => Number(v1.visibleposition) - Number(v2.visibleposition));
            otherList.sort((v1, v2) => Number(v1.visibleposition) - Number(v2.visibleposition));
            snapshotList = fiexedList.concat(requireList).concat(otherList);
        }
    }
    return { fiexedList, visibleItem: snapshotList };
}
//方案平铺
export function planExtend(searchInfo, items, context, result = [], level = 0) {
    if (Array.isArray(items)) {
        items.forEach(item => {
            if (item.children) {
                planExtend(searchInfo, item.children, context, result, ++level);
            } else {
                let initialvalue = {
                    display: '',
                    value: '',
                };
                item.initialvalue = item.initialvalue || item.value;
                let tempItem = searchInfo.itemsMap[item.attrcode];
                if (tempItem) {
                    if (tempItem.itemtype === 'checkbox_switch') {
                        if (initialvalue.value) {
                            initialvalue.value = true;
                        } else {
                            initialvalue.value = false;
                        }
                    } else if (tempItem.itemtype === 'refer' && item.initialvalue) {
                        let refervalue = getFunctionValueFromViewModal(item.initialvalue, context, tempItem.attrcode);
                        item.initialvalue.display = refervalue.display || item.initialvalue.display;
                    } else if (tempItem.itemtype === 'residtxt') {
                        let index = tempItem.languageMeta.filter(val => val.languageCode == localeLang)[0]?.index || 1;
                        initialvalue.index = index;
                        if (item.initialvalue && !item.initialvalue.hasOwnProperty('index')) {
                            item.initialvalue.index = index;
                        }
                    }
                    let obj = {
                        attrcode: item.attrcode,
                        refpk: item.attrcode,
                        initialvalue:
                            item.initialvalue &&
                                (item.initialvalue.value || item.initialvalue.value === false || item.initialvalue.display || item.initialvalue.index)
                                ? item.initialvalue
                                : initialvalue, //此处initialvalue判空可能有问题，调试的时候再改 xuyang
                        operationSign: item.operationSign || (item.queryOperateType && item.queryOperateType.replace(/^@+|\sic|@$/g, '').split('@')[0]) || '',
                        remove: item.hasOwnProperty('remove')
                            ? item.remove
                            : tempItem.required != true && tempItem.isfixedcondition != true,
                        visible: true,
                    };
                    if (tempItem.itemtype === 'refer') {
                        obj.runWithChildren = !!item.runWithChildren;
                        obj.refurl = item.refurl || '';
                    } else if (tempItem.itemtype === 'residtxt') {

                        obj.valueMap = {};
                        if (!item.hasOwnProperty('valueMap') && obj.initialvalue.value) {
                            obj.valueMap[item.attrcode + obj.initialvalue.index] = { value: obj.initialvalue.value };
                        } else if (item.hasOwnProperty('valueMap')) {
                            obj.valueMap = item.valueMap;
                        }

                    }
                    if (tempItem.isfixedcondition && level < 2) {
                        obj.visible = false;
                    }
                    result.push(obj);
                }
            }
        });
    }
    return result;
}
// 将查询方案转换成 snapshot
export function plan2snapshotTranslate(itemsMap, items, context, preSnapMap = {}, level = 0) {
    if (Array.isArray(items)) {
        items.forEach(item => {
            if (item.children) {
                item.children = plan2snapshotTranslate(itemsMap, item.children, context, preSnapMap, ++level);
            } else {
                let initialvalue = {
                    display: '',
                    value: '',
                };
                if (preSnapMap[item.attrcode]) {
                    item.initialvalue = preSnapMap[item.attrcode];
                }
                item.initialvalue = item.initialvalue || item.value;
                let tempItem = itemsMap[item.attrcode];
                if (tempItem) {
                    if (tempItem.itemtype === 'checkbox_switch') {
                        initialvalue.value = false;
                    } else if (tempItem.itemtype === 'refer' && item.initialvalue) {
                        let refervalue = getFunctionValueFromViewModal(item.initialvalue, context, tempItem.attrcode);
                        item.initialvalue.display = refervalue.display || item.initialvalue.display;
                    } else if (tempItem.itemtype === 'residtxt') {
                        let index = tempItem.languageMeta.filter(val => val.languageCode == localeLang)[0]?.index || 1;
                        initialvalue.index = index;
                        if (item.initialvalue && !item.initialvalue.hasOwnProperty('index')) {
                            item.initialvalue.index = index;
                        }
                    }

                    item.refpk = item.attrcode;
                    item.initialvalue =
                        item.initialvalue &&
                            (item.initialvalue.value || item.initialvalue.value === false || item.initialvalue.display || item.initialvalue.index)
                            ? item.initialvalue
                            : initialvalue; //此处initialvalue判空可能有问题，调试的时候再改 xuyang
                    item.operationSign = item.operationSign || (tempItem.queryOperateType && tempItem.queryOperateType.replace(/^@+|\sic|@$/g, '').split('@')[0]) || '';
                    item.operationOptions = createOperation(tempItem.queryOperateType);
                    item.remove = item.hasOwnProperty('remove')
                        ? item.remove
                        : tempItem.required != true && tempItem.isfixedcondition != true;
                    if (tempItem.itemtype === 'residtxt' && !item.hasOwnProperty('valueMap') && item.initialvalue.value) {
                        item.valueMap = {};
                        item.valueMap[item.attrcode + item.initialvalue.index] = { value: item.initialvalue.value };
                    }
                    item.visible = item.visible === false ? false : true;
                    //需要注释掉
                    // item.visible = !(!item.isfixedcondition && tempItem.isfixedcondition && level < 2);
                } else {
                    item.visible = false;
                }
            }
        });
        return items.filter(item => item.visible !== false);
    }
    return [];
}
//根据快照 过滤模板
export function templateFilter(itemsMap, snapshot) {
    let result = [];
    if (isArray(snapshot)) {
        snapshot.forEach(item => {
            if (itemsMap.hasOwnProperty(item.attrcode)) {
                result.push(itemsMap[item.attrcode]);
            }
        });
    }
    return result;
}

// 获得有数据的snapshot
export function snapshotFilter(snapshot, itemsMap) {
    if (Array.isArray(snapshot)) {
        return snapshot.filter(item => {
            return !isEmpty(item.initialvalue.value);
        });
    } else {
        return [];
    }
}
//查询条件所有值都添加了
export function allItemsFillComplete(snapshot, searchInfo, context) {
    let result = true;
    if (snapshot[0] && snapshot[0].attrcode == 'root') {
        snapshot = planExtend(searchInfo, snapshot, context);
    }
    snapshot.forEach(item => {
        let val = item.initialvalue;
        // 必填项无值 不执行查询 其他情况执行查询
        if (searchInfo.itemsMap[item.attrcode]['itemtype'] === 'refer') {
            val = getFunctionValueFromViewModal(item.initialvalue, context, item.attrcode);
        }
        if (searchInfo.itemsMap[item.attrcode]['required'] && isEmpty(val.value)) {
            result = false;
        }
    });
    return result;
}
//树结构转数组
export function tree2Array(data, reuslt = []) {
    if (Array.isArray(data)) {
        data.forEach(item => {
            if (item) {
                if (item.children) {
                    tree2Array(item.children, reuslt);
                } else {
                    reuslt.push(item);
                }
            }
        });
    }
    return reuslt;
}
//时间比较函数
export function CompareDate(d1, d2) {
    // console.log(d1, d2);
    return new Date(d1.replace(/-/g, '/')) > new Date(d2.replace(/-/g, '/'));
}
export function isDateFunction(value) {
    value = String(value);
    return value.indexOf('#') !== -1;
}

function addMark(data) {
    data.map(item => {
        if (
            item.initialvalue &&
            (item.initialvalue.value === '' ||
                item.initialvalue.value === null ||
                (isArray(item.initialvalue.value) && !item.initialvalue.value.length) ||
                (isArray(item.initialvalue.value) && item.initialvalue.value[0] === null))
        ) {
            item.isEmpty = true;
        } else {
            item.isEmpty = false;
        }
        if (Array.isArray(item.children)) {
            addMark(item.children);
        }
    });
}

/**
 * @description: 后台交互AJAX
 * @param {flag} String 交互类型 (edit编辑方案名称, save保存方案, add新增方案)
 * @param {type} Boolean 是否外层调用  
 * @param {currentPlanName} String 外层使用时传入的方案名称  
 * @return: 
 */
//新增的时候传一个isquicks:true或者false，代表是不是设置默认
export function beSureBtnClick(flag, type, currentPlan, searchPlanName, isquicks, scope, enter) {
    let currentPlanName = currentPlan.name;//要修改的方案的名称
    let searchPlan = this.state.searchInfo.searchPlanCache;
    let multiLang = this.state.json;
    let returnFlag = false;

    /**
     * 当flag为save时只需要判断是不是预置方案就可以；
     * 方flag为edit和add时要判断名称不能为空，不能和其他方案的名字相同
     * 当flag为edit时修改的名字和之前一样时直接return并关闭修改弹窗
     */

    if (flag === 'save') {
        if (currentPlan.isprepared === true) {
            toast({ content: multiLang['page-search-0016'], color: 'warning' });
            return;
        }
    } else if (flag === 'edit' || flag === 'add') {
        //如果名字和自己一样
        if (flag === 'edit' && currentPlan.name === searchPlanName) {
            if (!type) {
                this.props.modal.close('editSearchPlanName@' + this.props.moduleId);
            }
            return;
        }
        //如果名字为空
        if (searchPlanName.replace(/\s+/g, '') === '') {
            toast({ content: multiLang['page-search-0032'], color: 'warning' });
            returnFlag = true;
        } else {
            //如果和其他方案的名字一样
            let plan = searchPlan.find(item => item.name === searchPlanName);
            if (plan) {
                toast({ content: multiLang['page-search-0083'], color: 'warning' });
                returnFlag = true;
            }
        }
        if (returnFlag) {
            if (flag === 'add') {
                if (type) {
                    this.props.modal.show('outAddSearchPlan@' + this.props.moduleId);
                } else {
                    this.props.modal.show('addSearchPlan@' + this.props.moduleId);
                }
            } else {
                this.props.modal.show('editSearchPlanName@' + this.props.moduleId);
            }
            return;
        }
    }

    let that = this;
    let data = {
        public: null, // 公共区域查询条件
        nonpublic: null, // 非公共区域查询条件
    };
    let state = null;

    /*
    *    如果业务组自定义查询条件，保存方案时，需要业务组返回其自定义的查询条件
    *    状态：
    *    1、业务组只添加部分自定义查询条件，此时分两部分：公共查询区、自定义查询区
    *    2、业务组替换整个右侧body区，只有自定义查询区
    *    3、只有公共查询区
    * */

    // 获取公共查询区域查询条件及state
    let runThis = () => {
        let searchInfo = this.state.searchInfo;
        data.public = _getAllSearchData(searchInfo, false);
        if (searchInfo.status == 'super') {
            let child = searchInfo.snapshotMap.super[0].children.filter(item => item.isExtend !== true);
            state = [{ ...searchInfo.snapshotMap.super[0], children: child }];
        } else {
            state = searchInfo.snapshotMap[searchInfo.status].filter(item => item.isExtend !== true); //这块有问题xuyangt
        }

        addMark(state);
    };
    if (flag === 'save' || flag === 'add') {
        if (this.state.userControlAll) {
            // 业务组替换整个查询区
            data.nonpublic = this.props.saveSearchPlan();
        } else {
            data.nonpublic = typeof this.props.saveSearchPlan === 'function' ? this.props.saveSearchPlan() : null;
            runThis();
        }
    }

    let saveSearchPlanData = {
        pk_ncc_queryscheme: '',
        name: searchPlanName,
        conditionobj4web: data, //查询条件
        renderobj4web: state, // 查询条件前台数据结构，用于渲染查询区
        areaid: this.props.oid || this.props.meta.oid,
        isprepared: false, //预制方案
        isquickqs: false, //默认方案 ,只能修改，不能删除
    };

    if (currentPlan) {
        saveSearchPlanData.pk_ncc_queryscheme = currentPlan.pk_ncc_queryscheme;
        saveSearchPlanData.isprepared = currentPlan.isprepared;
        saveSearchPlanData.isquickqs = currentPlan.isquickqs;
        saveSearchPlanData.isdelete = currentPlan.isdelete;
    }

    // editAjax 修改方案名称
    let editAjax = () => {
        let newdate = this.state.searchInfo.searchPlanCache.find(item => (currentPlanName) == item.name);
        saveSearchPlanData.renderobj4web = newdate.renderobj4web;
        saveSearchPlanData.pk_ncc_queryscheme = newdate.pk_ncc_queryscheme;
        saveSearchPlanData.conditionobj4web = newdate.conditionobj4web || data;
        saveSearchPlanData.name = searchPlanName;
        saveAjax();
    };
    // saveAjax 修改方案保存
    let saveAjax = () => {
        // setTimeout(() => {
        Ajax({
            url: '/nccloud/riart/queryscheme/updateQS.do',
            data: saveSearchPlanData,
            loading: false,
            success: res => {
                if (res.success) {
                    {
                        toast({ content: multiLang['page-search-0033'], color: 'success' });
                    }
                    // 修改成功后，更新state数据
                    if (type == true) {
                        // 外部修改 
                        let i = that.state.searchInfo.searchPlanCache.findIndex(
                            e => e.pk_ncc_queryscheme === saveSearchPlanData.pk_ncc_queryscheme,
                        );
                        if (i !== -1) {
                            //更新searchPlanCache

                            //先注释掉
                            saveSearchPlanData.pk_ncc_queryscheme = res.data;

                            //先注释掉深拷贝
                            // that.state.searchInfo.searchPlanCache[i] = _clone({
                            //     ...that.state.searchInfo.searchPlanCache[i],
                            //     ...saveSearchPlanData,
                            // });
                            that.state.searchInfo.searchPlanCache[i] = {
                                ...that.state.searchInfo.searchPlanCache[i],
                                ...saveSearchPlanData,
                            };
                            if (currentPlanName == that.state.searchInfo.currentPlan.name) {
                                that.state.searchInfo.currentPlan = saveSearchPlanData;
                            }
                            //更新模板数据
                            that.searchPlanCacheChange(that.state.searchInfo.searchPlanCache);
                            let keySessionS = this._this.myState.search.keySessionS;
                            if (!isEmpty(keySessionS)) {
                                keySessionS.forEach(item => removeGlobalStorage('localStorage', item));
                            }

                        }
                        return;
                    }
                    // enter 键 关闭modal 
                    if (typeof enter === 'object' && enter.type === 'keydown') {
                        this.props.modal.close('editSearchPlanName@' + this.props.moduleId);
                    }
                    // 内部修改
                    let i = that.state.searchInfo.searchPlanCache.findIndex(
                        e => e.pk_ncc_queryscheme === saveSearchPlanData.pk_ncc_queryscheme,
                    );
                    if (i !== -1) {
                        // saveSearchPlanData.pk_ncc_queryscheme = res.data;
                        // that.state.searchPlan[i] = _clone({
                        //     ...that.state.searchPlan[i],
                        //     ...saveSearchPlanData,
                        // });
                        that.state.searchInfo.searchPlanCache[i] = {
                            // ...that.state.searchInfo.searchPlanCache[i],
                            ...saveSearchPlanData,
                        };
                        //更新模板数据
                        that.searchPlanCacheChange(that.state.searchInfo.searchPlanCache);
                    }
                    // this.state.currentPlan = saveSearchPlanData;
                    // 更新查询方案名称
                    // if (!this.state.userControlAll) {
                    //     setSearchPlanName.call(that._this, that.props.moduleId, saveSearchPlanData.name);
                    // }
                    // 当外层方案不是预置方案时 更新界面方案 当前保存的方案是 界面上展示的方案
                    // if (that.state.searchInfo.currentPlan) {
                    //     if (this.state.currentPlan.pk_ncc_queryscheme == that.state.searchInfo.currentPlan.pk_ncc_queryscheme) {
                    //         let a = _clone(this.state.currentPlan);
                    //         that.props.upDateSearchPlan(a);
                    //     }
                    // }
                    scope.setState({ currentPlan: that.state.searchInfo.searchPlanCache[i], searchPlanName: saveSearchPlanData.name });
                    //如果内部正在修改的方案和外部显示的一样，更新外部的方案
                    if (that.state.searchInfo.currentPlan.pk_ncc_queryscheme === saveSearchPlanData.pk_ncc_queryscheme) {
                        // that.state.searchInfo.currentPlan = that.state.searchInfo.searchPlanCache[i]
                        let a = _clone(that.state.searchInfo.searchPlanCache[i]);
                        scope.props.upDateSearchPlan(a);
                    }
                    let keySessionS = this._this.myState.search.keySessionS;
                    if (!isEmpty(keySessionS)) {
                        keySessionS.forEach(item => removeGlobalStorage('localStorage', item));
                    }
                }
            },
        });
        // }, 100);

    };

    let addAjax = () => {
        /* 避免新增方案时有pk */
        if (saveSearchPlanData.hasOwnProperty('pk_ncc_queryscheme')) {
            delete saveSearchPlanData.pk_ncc_queryscheme;
        }
        saveSearchPlanData.isquickqs = false;
        saveSearchPlanData.isprepared = false;
        saveSearchPlanData.isdelete = false;
        saveSearchPlanData.sequenc =
            ((Array.isArray(this.state.searchInfo.searchPlanCache) && this.state.searchInfo.searchPlanCache.length) || 0) + 1;
        // setTimeout(() => {
        Ajax({
            url: '/nccloud/riart/queryscheme/addQS.do',
            data: { nccQS: JSON.stringify(saveSearchPlanData), isDefaultDisplay: isquicks },
            success: res => {
                if (res.success) {
                    {
                        toast({ content: multiLang['page-search-0034'], color: 'success' });
                    }
                    // enter 键 关闭modal 
                    if (typeof enter === 'object' && enter.type === 'keydown') {
                        if (type === true) {
                            this.props.modal.close('outAddSearchPlan@' + this.props.moduleId);
                        } else {
                            this.props.modal.close('addSearchPlan@' + this.props.moduleId);
                        }
                    }
                    saveSearchPlanData.pk_ncc_queryscheme = res.data;
                    // saveSearchPlanData.pk_ncc_queryscheme = 'res.data' + Math.random();
                    const queryschemes = this.state.searchInfo.searchPlanCache;
                    //如果将新建的方案设为默认，那就将其他的isdefault都设为false
                    if (isquicks) {
                        // if (Array.isArray(queryschemes)) {
                        //     queryschemes.forEach(element => {
                        //         if (!element.isMyPlan) {
                        //             element.isquickqs = false;
                        //         }
                        //     });
                        // }
                        this.props.meta.defaultDisPlay = res.data;
                    }

                    queryschemes.push(_clone(saveSearchPlanData));
                    //更新模板数据
                    this.searchPlanCacheChange(queryschemes);
                    scope.setState({ checked: false });
                    // this.state.currentPlan = saveSearchPlanData;
                    // this.setState({ searchPlan: this.state.searchPlan, currentPlan: this.state.currentPlan });
                    // if (!this.state.userControlAll) {
                    //     setSearchPlanName.call(that.props._this._this, that.props.id, saveSearchPlanData.name);
                    // }
                    let keySessionS = this._this.myState.search.keySessionS;
                    if (!isEmpty(keySessionS)) {
                        keySessionS.forEach(item => removeGlobalStorage('localStorage', item));
                    }
                }
            },
        });
        // }, 100);

    };

    if (flag === 'edit') {
        //修改方案名称
        editAjax();
    } else if (flag === 'save') {
        // 直接保存 
        saveAjax();
    } else if (flag === 'add') {
        //添加新方案
        addAjax();
    }
}

/* 删除查询方案确定按钮 */
export function beSureBtnClick_Del(type, pk_ncc_queryscheme, scope) {
    // let pk = null;
    let that = this;
    // if (typeof type == 'boolean') {
    //     this.props = this;
    const multiLang = this.state.json;
    //     pk = pk_ncc_queryscheme;
    // } else {
    //     pk = this.state.currentPlan.pk_ncc_queryscheme;
    // }
    // setTimeout(() => {
    Ajax({
        url: '/nccloud/riart/queryscheme/deleteQS.do',
        data: { pk_ncc_queryscheme: pk_ncc_queryscheme },
        success: res => {
            if (res.success) {
                {
                    toast({ content: multiLang['page-search-0038'], color: 'success' });
                }
                const quickqs = this.state.searchInfo.searchPlanCache.find(item => item.isquickqs);
                //如果删除的是默认方案
                if (quickqs && this.props.meta.defaultDisPlay === pk_ncc_queryscheme) {
                    this.props.meta.defaultPrepared = quickqs.pk_ncc_queryscheme;
                    this.props.meta.defaultDisPlay = undefined;
                }
                // 外部修改
                if (type) {
                    this.state.searchInfo.searchPlanCache = this.state.searchInfo.searchPlanCache.filter(item => item.pk_ncc_queryscheme != pk_ncc_queryscheme);
                    // 修改模板的查询方案
                    this.props.meta.queryschemes = this.state.searchInfo.searchPlanCache.filter(item => item.pk_ncc_queryscheme != '001');
                    //如果删除的时当前选中的方案，就切换到快速查询方案或者预置方案
                    if ((this.state.searchInfo.currentPlan && this.state.searchInfo.currentPlan.pk_ncc_queryscheme) == pk_ncc_queryscheme) {
                        // let quickqs = this.state.searchInfo.searchPlanCache.find(item => item.isquickqs);
                        if (quickqs) {
                            this.state.chooseSearchPlan(quickqs);
                        } else {
                            this.state.chooseSearchPlan(this.state.searchInfo.defaultPlan);
                        }
                    }
                    //删除localstorage中的模板数据
                    let keySessionS = this._this.myState.search.keySessionS;
                    if (!isEmpty(keySessionS)) {
                        keySessionS.forEach(item => removeGlobalStorage('localStorage', item));

                    }
                    this.setState({ searchInfo: this.state.searchInfo });
                    return;
                }

                // let i = this.state.searchPlan.length;
                // while (i--) {
                //     let item = this.state.searchPlan[i];
                //     if (item.pk_ncc_queryscheme === this.state.currentPlan.pk_ncc_queryscheme) {
                //         this.state.searchPlan.splice(i, 1);
                //         this.props.searchPlanCacheChange(this.state.searchPlan);
                //         break;
                //     }
                // }
                this.state.searchInfo.searchPlanCache = this.state.searchInfo.searchPlanCache.filter(item => item.pk_ncc_queryscheme != pk_ncc_queryscheme);
                // 修改模板的查询方案
                this.props.meta.queryschemes = this.state.searchInfo.searchPlanCache.filter(item => item.pk_ncc_queryscheme != '001');
                // let quickqs = this.state.searchInfo.searchPlanCache.find(item => item.isquickqs);
                if (scope.state.currentPlan.pk_ncc_queryscheme === pk_ncc_queryscheme) {
                    if (quickqs) {
                        scope.clickSearchPlan(quickqs);
                    } else {
                        scope.clickSearchPlan(this.state.searchInfo.defaultPlan);
                    }
                }
                // 删除外部方案
                if (pk_ncc_queryscheme === (this.state.searchInfo.currentPlan && this.state.searchInfo.currentPlan.pk_ncc_queryscheme)) {
                    if (quickqs) {
                        scope.props.upDateSearchPlan(quickqs);
                    } else {
                        scope.props.upDateSearchPlan(this.state.searchInfo.defaultPlan);
                    }
                }

                //删除localstorage中的模板数据
                let keySessionS = this._this.myState.search.keySessionS;
                if (!isEmpty(keySessionS)) {
                    keySessionS.forEach(item => removeGlobalStorage('localStorage', item));
                }
                scope.setState({ currentPlan: quickqs || this.state.searchInfo.defaultPlan });
            }
        },
    });
    // }, 100);

}
//ajax参数 pk_ncc_queryscheme ; areaId; isNotQS
export function setDefaultScheme(type, currentPlan, pk_ncc_queryscheme, areaId) {
    const data = { areaId };
    if (pk_ncc_queryscheme === "001") {
        data.pk_ncc_queryscheme = '00000000000000000000';
    } else {
        data.pk_ncc_queryscheme = pk_ncc_queryscheme;
    }
    // setTimeout(() => {
    Ajax({
        url: '/nccloud/riart/queryscheme/setDefaultQS.do',
        data: data,
        loading: false,
        success: res => {
            if (res.success) {

                // 外部修改
                if (type) {
                    //更新state中的方案 将当前设置的方案的default设置为true，将其他方案的isdefault设置为false
                    // 修改模板的查询方案
                    // const queryschemes = this.props.meta.queryschemes;
                    // if (Array.isArray(queryschemes)) {
                    //     queryschemes.forEach(element => {
                    //         if (element.pk_ncc_queryscheme === pk_ncc_queryscheme) {
                    //             element.isquickqs = true;
                    //         } else {
                    //             element.isquickqs = false;
                    //         }
                    //     });
                    // }
                    this.props.meta.defaultDisPlay = pk_ncc_queryscheme;
                    //如果需要切换到当前设置的方案，那就切换方案，不需要就算了
                    // currentPlan.isquickqs = true;
                    // this.state.chooseSearchPlan(currentPlan);
                    //删除localstorage中的模板数据
                    let keySessionS = this._this.myState.search.keySessionS;
                    if (!isEmpty(keySessionS)) {
                        keySessionS.forEach(item => removeGlobalStorage('localStorage', item));
                    }
                    this.setState({ searchInfo: this.state.searchInfo });
                    return;
                }

            }
        },
        // }, 100);
    });
}

